<template>
  <div>
    <v-form
      ref="stepOneForm"
      v-model="valid"
    >
      <v-select
        v-model="prodviewType"
        :items="prodviewtype"
        :label="$trans('v2.fm2.productionview.prodviewtype')"
        :rules="typeRule"
        required
        item-text="text"
        item-value="value"
      />
      <v-text-field
        v-model="prodviewName"
        :label="$trans('v2.fm2.productionview.name')"
        :rules="nameRule"
        required
      />
    </v-form>
  </div>
</template>

<script>

export default {
  props: {
    prodviewtype: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data: () => ({
    prodviewType: [],
    prodviewName: '',
    valid: true,
    typeRule: [
      (v) => !!v || t`v2.fm2.productionview.required`,
      (v) => (v && v.length > 0) || t`v2.fm2.productionview.required`,
    ],
    nameRule: [
      (v) => !!v || t`v2.fm2.productionview.required`,
      (v) => (v && v.length >= 3) || t`v2.fm2.productionview.minlength3`,
      (v) => (v && v.length < 128) || t`v2.fm2.productionview.maxlength128`,
    ],
  }),
  methods: {
    stepTwo() {
      if (this.$refs.stepOneForm.validate()) {
        this.$emit('setstep1values', this.prodviewType, this.prodviewName);
        return true;
      }
      return false;
    },
    setValues(name, viewType) {
      this.prodviewName = name;
      this.prodviewType = viewType;
    },
  },
};
</script>
